import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Dividas from './pages/Dividas';
import Receitas from './pages/Receitas';
import Despesas from './pages/Despesas';
import Insights from './pages/Insights';
import Perfil from './pages/Perfil';
import Contas from './pages/Contas';
import Cartoes from './pages/Cartoes';
import Navbar from './components/Navbar';
import './App.css';

function ProtectedRoute({ children }) {
  const { token } = useContext(AuthContext);
  return token ? children : <Navigate to="/login" />;
}

function AppContent() {
  const { token } = useContext(AuthContext);
  return (
    <BrowserRouter>
      {token && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/dividas" element={<ProtectedRoute><Dividas /></ProtectedRoute>} />
        <Route path="/receitas" element={<ProtectedRoute><Receitas /></ProtectedRoute>} />
        <Route path="/despesas" element={<ProtectedRoute><Despesas /></ProtectedRoute>} />
        <Route path="/contas" element={<ProtectedRoute><Contas /></ProtectedRoute>} />
        <Route path="/cartoes" element={<ProtectedRoute><Cartoes /></ProtectedRoute>} />
        <Route path="/insights" element={<ProtectedRoute><Insights /></ProtectedRoute>} />
        <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>;
}
